module.exports = __webpack_public_path__ + "img/check-list3.031a7b4d.png";